import React from 'react'
import { useMutation } from 'react-query'
import { toast } from 'react-toastify'
import { settingSMS } from 'services/setting'

export default function useSetSms(refetch: () => void) {
    const { isLoading, mutate } = useMutation({
        mutationFn: (payload: ISettingSMSPayload) => {
            return settingSMS(payload)
        },
        onSuccess: (data) => {
            refetch()
            toast.success('تغییرات با موفقیت انجام شد')
        },
        onError: () => {
            toast.error('مشکلی پیش آمده!')
        },
    })

    return { mutate }
}
